import FooterTextil from './FooterTextil';

export default FooterTextil;
